export default function AthleteSection() {
  const athleteTypes = [
    'Ironman Triathletes',
    'Marathon Runners',
    'Ultra Cyclists',
    'Ultra Runners'
  ];

  return (
    <section className="bg-black py-32 lg:py-40">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Image */}
          <div className="order-2 lg:order-1">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/3472be4e5de6bd29dbe33db569577434.jpg"
                alt="Endurance athlete"
                className="w-full h-auto object-cover"
                style={{ filter: 'contrast(1.2) saturate(0.8)' }}
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2 lg:pl-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-10 leading-tight">
              Built For Endurance Athletes
            </h2>

            <div className="space-y-6 mb-12">
              <p className="text-lg lg:text-xl text-white/70 leading-relaxed max-w-[500px]">
                THRESH was built by a triathlete training for Ironman who couldn't find a fueling system that actually worked at volume. Too many gels. Too much foam. Too many restrictions on how much you could carry or mix.
              </p>

              <p className="text-lg lg:text-xl text-white/70 leading-relaxed max-w-[500px]">
                So we built the system we wanted. Unflavored carbs you can dose from 30g to 120g in any bottle. A complete electrolyte matrix with the forms that actually absorb — not the cheap versions. And precision caffeine you can time exactly, without it being bundled into your carbs.
              </p>

              <p className="text-lg lg:text-xl text-white/70 leading-relaxed max-w-[500px]">
                Every formula choice has a peer-reviewed study behind it. Every dose is matched to what endurance athletes actually lose and need at race pace. This is not a supplement company's idea of what an athlete needs. This is an athlete's solution.
              </p>
            </div>

            {/* Athlete Types */}
            <div className="space-y-4">
              {athleteTypes.map((type, index) => (
                <div key={index} className="flex items-center gap-4">
                  <i className="ri-arrow-right-line text-2xl text-[#00FF88]"></i>
                  <span className="text-lg text-white font-medium">{type}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}